import { motion } from "framer-motion";
import { Reveal, SectionHeading } from "@/components/shared";
import { STEPS } from "@/data/content";

export default function HowItWorks() {
  return (
    <section className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid gap-14 lg:grid-cols-[1fr_1.5fr] lg:gap-20">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <SectionHeading
              eyebrow="Como funciona"
              title={<>Método em <span className="text-gold-grad">6 etapas</span></>}
              sub="Um ciclo completo — do primeiro diagnóstico ao registro que protege o condomínio para sempre."
            />
          </div>
          <div className="relative">
            <motion.span
              initial={{ scaleY: 0 }}
              whileInView={{ scaleY: 1 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
              className="absolute left-[15px] top-2 h-[calc(100%-16px)] w-px origin-top bg-gradient-to-b from-gold via-gold/40 to-transparent"
            />
            <div className="space-y-10">
              {STEPS.map((step, i) => (
                <Reveal key={step.step} delay={i * 0.06}>
                  <div className="relative flex gap-7 pl-0">
                    <span className="relative z-10 mt-1 flex h-8 w-8 shrink-0 items-center justify-center border border-gold/40 bg-navy-950 font-mono text-[11px] text-gold">
                      {step.step}
                    </span>
                    <div className="group border-b border-white/5 pb-8">
                      <h3 className="font-display text-2xl font-bold uppercase tracking-wide text-white transition-colors duration-300 group-hover:text-gold">
                        {step.name}
                      </h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-slate-400">{step.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
